// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"401":"3a592fe3","978":"36975b9f"}[chunkId] + ".chunk.css";
};